import { IUtente } from './../interfaces/IUtente';
import { IGruppo } from './../interfaces/IGruppo';
import { LogAttivitaService } from './../services/logattivita.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as Enum from '../utils/enums'
import { finalize } from 'rxjs/operators';
import { RequestBuilder } from '../classes/request-builder';
import { GruppoService } from '../services/gruppo.service';
import { AlertUtil } from '../utils/alert-util';
import { Loading } from '../utils/loading';
import { UtenteService } from '../services/utente.service';
import { ILogAttivita } from '../interfaces/ILogAttivita';
import * as Moment from 'moment'
import { Util } from '../utils/util';
import { DataTableComponent } from '../data-table/data-table.component';

@Component({
  selector: 'app-log-attivita',
  templateUrl: './log-attivita.component.html',
  styleUrls: ['./log-attivita.component.css']
})
export class LogAttivitaComponent implements OnInit {

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html

  listaLogAttivita: ILogAttivita[]

  //DROPDOWN
  listaGruppi: IGruppo[]
  listaUtenti: IUtente[]
  listaOperazioni: any[]

  //FILTER
  gruppoSelected: IGruppo = null
  utenteSelected: IUtente = null
  operazioneSelected: any = null
  dataDalSelected: Date = null
  dataAlSelected: Date = null

  it: any                               // Lingua del calendario

  @ViewChild("dtLogAttivita") dtLogAttivita: DataTableComponent

  constructor(private gruppoService: GruppoService,
    private alertUtil: AlertUtil,
    private utenteService: UtenteService,
    private logAttivitaService: LogAttivitaService) {
    this.setListOperazioni();
  }

  ngOnInit() {
    this.setLanguageForCalendar()
    setTimeout(() => {
      this.getAllUtenti()
      this.getAllGruppi()
      this.getAllLogs()
    }, 0);
  }

  /**
  * language for calendar
  */
  setLanguageForCalendar() {
    /**
    * Lingua italiana nel calendario
    */
    this.it = {
      firstDayOfWeek: 1,
      dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
      monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
      today: 'Oggi',
      clear: 'Cancella'
    };
  }
  /**
   * fetch gruppi
   */
  getAllGruppi() {
    this.listaGruppi = []
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.gruppoService.getAllGruppi(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.listaGruppi = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * fetch all utenti
   */
  getAllUtenti() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(this.setPayloadUtente())
    this.utenteService.getAllUtenti(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.listaUtenti = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * set payload for API
   */
  setPayloadUtente() {
    let payloadUtente = {
      ApplicationName: "/"
    }
    return payloadUtente
  }

  /**
   * fecth log with filter
   */
  getAllLogs() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(this.getPayloadFilter())
    this.logAttivitaService.getAllLog(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.dtLogAttivita.resetTable()
          this.listaLogAttivita = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * filtra button
   */
  onFiltra() {
    this.getAllLogs()
  }

  /**
   * payload for fetch log
   */
  getPayloadFilter() {
    //filtro lato BE
    let payload: any = {
      IdGruppo: this.gruppoSelected ? this.gruppoSelected.Id : 0,
      IdUtente: this.utenteSelected ? this.utenteSelected.UserId : "",
      Operazione: this.operazioneSelected ? this.operazioneSelected.Id : "",
      DateFrom: this.dataDalSelected ? this.formatDateForFilter(this.dataDalSelected) + " 00:00:00" : "",
      DateTo: this.dataAlSelected ? this.formatDateForFilter(this.dataAlSelected) + " 23:59:59" : ""
    }
    return payload
  }

  /**
   * export excel
   */
  onDownloadLog() {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder(this.getPayloadFilter())
    this.logAttivitaService.exportLog(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response && response["error"] == null) {
        Util.downloadFile(response, Enum.FILE_TYPE_ENUM.XLSX, "Log_Attività")
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    }, error => {
      let errorKey = "LBL_HTTP_ERROR_0"
      if (error.status) {
        errorKey = "LBL_HTTP_ERROR_" + error.status
      }
      this.alertUtil.showErrorAlert(errorKey)
    })
  }

  /**
   * set list operazioni for dropdown filter
   */
  private setListOperazioni() {
    this.listaOperazioni = [
      { Id: "Login", Descrizione: "Login" },
      { Id: "Logout", Descrizione: "Logout" },
      { Id: "Validazione", Descrizione: "Validazione" },
      { Id: "Rigetto", Descrizione: "Rigetto" },
      { Id: "Allega_File", Descrizione: "Allega File" },
      { Id: "Cancellazione_File", Descrizione: "Cancellazione File" },
      { Id: "Accettazione_Gdpr", Descrizione: "Accettazione GDPR"},
      { Id: "Delete_Intervento", Descrizione: "Cancellazione Intervento"},
      { Id: "Delete_Richiesta", Descrizione: "Cancellazione Richiesta"}
    ];
  }


  /**
  * format date to YYYY-MM-DDTHH:mm:ss.000 from YYYY-MM-DD
  * @param dateValue item value
  */
  private formatDateForFilter(dateValue: Date): string {
    return Moment(dateValue).format("YYYY-MM-DD")
  }

}
